(function() {
  'use strict';

  function ProfileTemplatesController(
    ProfileTemplates,
    ProfileTemplatesUtils,
    List,
    Auth,
    Security,
    $translate,
    Utils,
    Notify,
    DEFAULT_PROFILE_TEMPLATE
  ) {
    var ctrl = this;

    Utils.setPageTitle('Summary templates');

    ctrl.pageTitle = 'Summary templates';
    ctrl.templateType = 'profile';

    ctrl.list = new List({
      search: ProfileTemplatesUtils.search,
      model: ProfileTemplatesUtils.searchModel,
      idField: '_id'
    });

    ctrl.options = {
      trackBy: '_id',
      borderClass: function(item) {
        return ProfileTemplatesUtils.getBorderClass(item);
      }
    };

    ctrl.actions = [{
      label: $translate.instant('New'),
      icon: 'icon-edit',
      route: ['/profile-templates/new'],
      showCondition: Security.hasPermission.bind(this, 'profileTemplates.edit'),
      klass: 'btn-success'
    }];

    var createDefaultDashboard;
    var loadItems;

    /**
     * Create the default dashboard template and save it.
     * This will only happen if there is no default dashboard template.
     * @param  {Boolean} shouldCreate True if there is no default template, false otherwise.
     * @return {Promise}              A promise with whether the default template has been saved.
     */
    createDefaultDashboard = function() {
      // We get the default document structure
      // and then we extend it with some sensible defaults
      var defaultDashboard = _.assign(
        {},
        ProfileTemplatesUtils.getDocDefault(Auth.currentOrganisation()),
        {
          title: 'Default summary template',
          template: _.assign({}, DEFAULT_PROFILE_TEMPLATE, { title: 'Default summary template' }),
          isDefault: true
        }
      );

      // We save the template and display a toastr notice to the user
      // if the save has been successful
      // We also reload the list of templates
      return ProfileTemplates.save(defaultDashboard)
              .then(function() {
                Notify.success(
                    'It looks like you didn\'t create a default summary template, ' +
                    'so we\'ve created one for you!',
                    'Default summary template created'
                );
              })
              .catch(Utils.showError);
    };

    /**
     * Load the list of dashboard templates.
     * @param {Boolean} skipDefaultDashboardCheck Should we check for the default dashboard or not?
     * @return {void}
     */
    loadItems = function() {
      ProfileTemplates.findAll({ cached: false, maxAge: 0 })
        .then(function(items) {
          if (ProfileTemplatesUtils.noDefaultTemplate(items)) {
            // Create and reload
            return createDefaultDashboard()
              .then(function() {
                return ProfileTemplates.findAll({ cached: false, maxAge: 0 });
              });
          }
          return items;
        })
        .then(function(items) {
          return ctrl.list.doLoadItems(items);
        })
        .catch(Utils.showError);
    };

    // Let's jumpstart everything
    loadItems();
  }

  ProfileTemplatesController.$inject = [
    'ProfileTemplatesService',
    'ProfileTemplatesUtilsService',
    'ListFactory',
    'AuthService',
    'SecurityService',
    '$translate',
    'UtilsService',
    'NotifyService',
    'DEFAULT_PROFILE_TEMPLATE'
  ];

  angular.module('component.dashboardTemplates')
    .controller('ProfileTemplatesController', ProfileTemplatesController);
})();
